'use strict';


export default function(direction) {
	return function($compile) {
		'ngInject';

		return {
			require: '^brgRestQuery',
			compile: compile,
		};

		function compile(tElement, tAttrs) {
			tElement.removeAttr(`brg-rest-query-${direction}`);
			tAttrs.$set('ng-disabled', `!$query.${direction}Url`);
			return {
				post: function(scope, element, attrs, $query) {
					element.on('click', function() {
						$query.query($query[`${direction}Url`]);
					});
					$compile(element)(scope);
				},
			}
		}
	}
}
